var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c(
      "a",
      {
        staticClass: "has-toggle",
        class: { "is-active": _vm.current === _vm.category.id },
        on: {
          click: function($event) {
            return _vm.$emit("update:current", _vm.category.id)
          }
        }
      },
      [
        _c(
          "div",
          {
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.expand = !_vm.expand
              }
            }
          },
          [
            _c("b-icon", {
              attrs: { icon: _vm.expand ? "minus-square" : "plus-square" }
            })
          ],
          1
        ),
        _vm._v(
          "\n    " + _vm._s(_vm.$t("proprio.id" + _vm.category.id)) + "\n  "
        )
      ]
    ),
    _vm.expand
      ? _c(
          "ul",
          _vm._l(_vm.category.subCategories, function(item) {
            return _c("li", { key: item.id }, [
              _c(
                "a",
                {
                  class: { "is-active": _vm.current === item.id },
                  on: {
                    click: function($event) {
                      return _vm.$emit("update:current", item.id)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
              )
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }